export default __webpack_public_path__ + "static/media/ABChanelCorpo-ExtraLight.73b32b03.woff2";